export const errorConstants = {
  wrongPassword: "wrongPassword",
  emailNotFound: "emailNotFound",
  userIsNotVerified: "userIsNotVerified",

  registrationEmailAlreadyExists: "emailAlreadyExists"
};
